<template>
  <div class="box_fa mt-14">
    <n-table :bordered="false" :single-line="false">
      <thead>
        <tr>
          <th>发票金额</th>
          <th>交易完成时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody v-for="(item, index) in dataP.value" :key="index">
        <tr>
          <td>{{ item.amount }}</td>
          <td>{{ item.endTime }}</td>
          <td>
            <n-button v-if="item.invoiceStep === '0'" type="success" @click="submit(item)">
              申请
            </n-button>
            <n-button v-if="item.invoiceStep === '2'" type="success" @click="downloadInvoice(item)">
              下载
            </n-button>
            <n-button v-if="item.invoiceStep === '1'" type="success"> 等待审核 </n-button>
          </td>
        </tr>
      </tbody>
    </n-table>
    <!--    申请 弹框 开始-->
    <n-modal v-model:show="showModal" :mask-closable="false">
      <n-card style="width: 800px" title="发票申请" :bordered="false" size="huge">
        <div>
          <n-form
            :model="formValue"
            ref="formRef"
            :rules="formRules"
            size="large"
            label-placement="left"
            :label-width="120"
          >
            <n-form-item label="请选择发票类型" path="invoiceType">
              <n-space vertical>
                <n-select
                  style="width: 300px"
                  v-model:value="formValue.invoiceType"
                  placeholder="请选择"
                  :options="options"
                  @update:value="updateSelect"
                />
              </n-space>
            </n-form-item>
            <n-form-item label="开票账户名称" path="account">
              <n-input placeholder="开票账户名称" v-model:value="formValue.account" />
            </n-form-item>
            <n-form-item label="地址" path="address" v-if="formValue.invoiceType === '2'">
              <n-input placeholder="地址" v-model:value="formValue.address" />
            </n-form-item>
            <n-form-item label="联系电话" path="tel" v-if="formValue.invoiceType === '2'">
              <n-input placeholder="联系电话" v-model:value="formValue.tel" />
            </n-form-item>
            <n-form-item
              label="开票账户税号"
              path="dutyParagraph"
              v-if="formValue.invoiceType === '2'"
            >
              <n-input placeholder="开票账户税号" v-model:value="formValue.dutyParagraph" />
            </n-form-item>
            <n-form-item label="开户行全称" path="bank" v-if="formValue.invoiceType === '2'">
              <n-input placeholder="开户行全称" v-model:value="formValue.bank" />
            </n-form-item>
            <n-form-item
              label="支行开户行账号"
              path="bankAccount"
              v-if="formValue.invoiceType === '2'"
            >
              <n-input placeholder="支行开户行账号" v-model:value="formValue.bankAccount" />
            </n-form-item>
            <n-form-item>
              <div class="ml-auto">
                <el-button type="info" @click="cancel">取消</el-button>
                <el-button type="success" @click="save">保存</el-button>
              </div>
            </n-form-item>
          </n-form>
        </div>
      </n-card>
    </n-modal>
    <!--    申请 弹框 结束-->
  </div>
</template>

<script setup>
import { NSpace } from 'naive-ui';
import { getDownloadUrl } from '../../../utils/ali-oss';
import { webMyInvoice, webApply } from '@/api';
import { ref, reactive, onMounted, onUpdated, onUnmounted } from 'vue';

const dataP = reactive([]);
const showModal = ref(false);

const options = [
  { label: '个人', value: '1' },
  { label: '公司', value: '2' },
];
const formRef = ref(null);
const formValue = ref({
  invoiceType: '', // 发票类型 1个人 2 公司
  account: '', // 开票信息-开票账户名称
  address: '', // 地址
  bank: '', // 开户行全称
  dutyParagraph: '', // 开票账户税号
  bankAccount: '', // 支行开户行账号
  tel: '', // 联系电话
  payId: '', // 支付id
  amount: '', // 支付金额s
});
const formRules = {
  invoiceType: [
    {
      required: true,
      message: '请选择发票类型',
      trigger: 'blur',
    },
  ],
  account: [
    {
      required: true,
      message: '请输入账户名称',
      trigger: 'blur',
    },
  ],
  address: [
    {
      required: true,
      message: '请输入地址',
      trigger: 'blur',
    },
  ],
  bank: [
    {
      required: true,
      message: '请输入开户行全称',
      trigger: 'blur',
    },
  ],
  dutyParagraph: [
    {
      required: true,
      message: '请输入开票账户税号',
      trigger: 'blur',
    },
  ],
  bankAccount: [
    {
      required: true,
      message: '请输入支行开户行账号',
      trigger: 'blur',
    },
  ],
  tel: [
    {
      required: true,
      message: '请输入联系电话',
      trigger: 'blur',
    },
  ],
};

function submit(item) {
  console.log(item);
  formValue.value.payId = item.id;
  formValue.value.amount = item.amount;
  showModal.value = true;

  console.log(formValue.value);
}

function save(value) {
  formRef.value.validate(errors => {
    if (!errors) {
      console.log('完成');
      console.log(formValue.value);
      webApply(formValue.value).then(res => {
        console.log(res);
        if (res.data.success === true) {
          showModal.value = false;
          initial();
        } else {
          window.message.error(res.data.msg);
        }
      });
    } else {
      console.log('信息请填写完整');
    }
  });
}

function updateSelect(e) {
  console.log(formValue.value.invoiceType);
  if (formValue.value.invoiceType === '1') {
    formValue.value.address = '';
    formValue.value.bank = '';
    formValue.value.dutyParagraph = '';
    formValue.value.bankAccount = '';
    formValue.value.tel = '';
  } else if (formValue.value.invoiceType === '2') {
    formValue.value.account = '';
  }
}

function cancel() {
  showModal.value = false;
}

// 验证
function handleValidateClick(e) {
  formRef.value.validate(errors => {
    if (!errors) {
      window.message.success('Valid');
    } else {
      console.log(errors);
      window.message.error('Invalid');
    }
  });
}

// 下载pdf
function downloadInvoice(item) {
  let pdf = getDownloadUrl(item.invoiceAddr, '叶万林' + '.pdf');
}

function initial() {
  webMyInvoice({ current: 1, type: 100 }).then(res => {
    console.log(res);
    if (res.success === true) {
      dataP.value = res.data;
      console.log(dataP.value.length);
    }
  });
}

onMounted(() => {
  console.log('初始了哈哈');
  initial();
});
</script>

<style lang="scss" scoped>
.box_fa {
  border: 1px solid #d1d5db;
}
</style>
